import React, { useState } from "react";
import Dashboard from "../Dashboard";
import ListShipping from "../../../features/adminDashboard/shipping/ListShipping";
import CreateShipping from "../../../features/adminDashboard/shipping/CreateShipping";

function Shipping() {
  const [activeTab, setActiveTab] = useState("list");

  return (
    <Dashboard>
      <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
        <button
          onClick={() => setActiveTab("list")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "list"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          list shipping
        </button>
        <button
          onClick={() => setActiveTab("create")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "create"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          Create Shipping
          {/* {editingProduct ? "Edit Product" : "Create Product"} */}
        </button>
      </div>
      {activeTab === "list" && <ListShipping onSetActiveTab={setActiveTab} />}
      {activeTab === "create" && (
        <CreateShipping onSetActiveTab={setActiveTab} />
      )}
    </Dashboard>
  );
}

export default Shipping;
